import { render } from "./LoaderItem.vue?vue&type=template&id=1b70f2e4"
import script from "./LoaderItem.vue?vue&type=script&lang=js"
export * from "./LoaderItem.vue?vue&type=script&lang=js"

import "./LoaderItem.vue?vue&type=style&index=0&id=1b70f2e4&lang=css"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__